import { useSyncExternalStore } from 'react';
import { DEFAULT_MOTION_PLAYBACK_RATE, isMotionPlaybackRate } from './motionPlayback';

const STORAGE_KEY = 'ting-vision:motion-playback-rate:v1';
const CHANGE_EVENT = 'ting-vision:motion-playback-rate-changed';
let inMemoryPreference = DEFAULT_MOTION_PLAYBACK_RATE;
let storageUnavailable = false;

export function getMotionPlaybackRate() {
  if (storageUnavailable) return inMemoryPreference;
  try {
    const value = Number(window.sessionStorage.getItem(STORAGE_KEY));
    return isMotionPlaybackRate(value) ? value : DEFAULT_MOTION_PLAYBACK_RATE;
  } catch (_) { return inMemoryPreference; }
}

function subscribe(listener) {
  window.addEventListener(CHANGE_EVENT, listener);
  return () => window.removeEventListener(CHANGE_EVENT, listener);
}

function setPlaybackRate(value) {
  if (!isMotionPlaybackRate(value)) return;
  inMemoryPreference = value;
  try { window.sessionStorage.setItem(STORAGE_KEY, String(value)); }
  catch (_) { storageUnavailable = true; }
  window.dispatchEvent(new Event(CHANGE_EVENT));
}

export default function useMotionPlaybackPreference() {
  const speed = useSyncExternalStore(subscribe, getMotionPlaybackRate, () => DEFAULT_MOTION_PLAYBACK_RATE);
  return [speed, setPlaybackRate];
}
